module.exports = __webpack_public_path__ + "static/img/youhuijuan.49fd052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view6/youhuijuan.png
// module id = l1HK
// module chunks = 1